import { Injectable } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'

@Injectable({
  providedIn: 'root'
})
export class NotificationMessageService {
  constructor(private snackBar: MatSnackBar) {}

  public openSnackBar(success: boolean, message: string): void {
    let cssClass: string
    if (success) {
      cssClass = 'snackbar'
    } else {
      cssClass = 'snackbar--warning'
    }
    this.snackBar.open(message, null, {
      duration: 2500,
      panelClass: [cssClass]
    })
  }
}
